import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import { useCurrencyLocalizer } from "../Shared/hooks/useCurrencyLocalizer";
/**
 * Displays the total and a skeleton when total is updating
 *
 * @param total
 * @param loading
 * @returns
 */
export const TotalDisplay = ({ total }) => {
    const { localizedCurrencyText } = useCurrencyLocalizer(total > 0 ? total : 0);
    return _jsx(_Fragment, { children: localizedCurrencyText });
};
